<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14uCvyC/tc-custom/9781612009094.jpg?1712806265346" alt="This image is the cover for the book Air War on the Eastern Front, Casemate Illustrated"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Air War on the Eastern Front, Casemate Illustrated
      </h1>
      <p class="bookDescription body article font2">
        <b>A pictorial history of Nazi Germany’s entire air campaign against the Soviet Union on the Eastern Front in World War II.</b><br/><br/>The Red Air Force versus the Luftwaffe in the skies over Eastern Europe. June 1941: Having conquered most of Western Europe, Adolf Hitler turned his attention to the vast Soviet Union. Disregarding his Non-Aggression Pact with Joseph Stalin, Hitler launched Operation Barbarossa, a full-scale invasion of the Soviet homeland . . . aimed squarely at Moscow.<br/><br/>In the skies over Russia, the battle-hardened airmen of the Luftwaffe made short work of the Red Air Force during opening days of Barbarossa. To make matters worse, Stalin had executed many of his best pilots during the perennial “purges” of the 1930s. Thus, much of the Red Air Force was destroyed on the ground before meeting the Luftwaffe in the skies. By 1944, however, the Soviet airmen had regained the initiative and fervently wrested air superiority from the now-ailing Axis Powers.<br/><br/><b>“Will be of great interest to both modelers and aircraft historians alike.” —<i>AMPS Indianapolis</i></b><br/><br/><b>“This slim survey provides a quick, convenient intro to the deadly totalitarian duel. Make it a launchpad to further study of Eastern Front air combat in WWII.” —<i>Cybermodeler</i></b><br/><br/><b>“The prose is smooth and provides a top-level look at WWII German and Soviet air warfare.” —<i>Historical Miniatures Gaming Society</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mike Guardia
      </h2>
      
      <p class="authorDescription body article">Mike Guardia is an internationally recognized author and military historian. A veteran of the United States Army, he served six years on active duty as an Armor Officer. He has twice been nominated for the Army Historical Foundation's Distinguished Book Award and is an active member in the Military Writers Society of America.  He holds a BA and MA in American History from the University of Houston. He currently lives in Minnesota.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Casemate Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d06ef04